
import React from 'react';
import { Alert, Badge, Box, Button, Card, CardContent, CardHeader, Container, Grid, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { set } from 'firebase/database';
import axios from 'axios';
import { getValidAccessToken } from '../utils/tokenUtils';
import Loader from '../utils/Loader';

const styles = {
    th: {
      backgroundColor: '#07223d',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '0.875rem',
      padding: '8px',
      textAlign: 'left',
    },
    td: {
      padding: '8px',
      borderBottom: '1px solid #ddd',
    },
  };
  const apiUrl = process.env.REACT_APP_API_URL;

const AllUsers = () => {
    const [errorMessage, setErrorMessage] = React.useState('');
    const [users, setUsers] = React.useState([]);
    const [employees, setEmployees] = React.useState([]);
    const [activeTab, setActiveTab] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    

    React.useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            const token = await getValidAccessToken();
            try {
                const response = await axios.get(`${apiUrl}/users/all-users`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUsers(response.data.data.users || []);
                setEmployees(response.data.data.non_users || []);
                setLoading(false);
            } catch (error) {
                setErrorMessage('Failed to fetch users.');
                setLoading(false);
            }
        }
        fetchUsers();
    } , []);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
      };
    if(loading) {
        return (
            <Container style={{ padding: '10px', width: 'auto' }}>
                <Box sx={{ mt: 1, mb: 1 }}>
                    <Typography variant="h4" align="center" gutterBottom>
                        All Users
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                        <Loader />
                    </Box>
                </Box>
            </Container>
        );
    }
    const renderTable = (data) => (
        <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {data.map((user, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 3,
                p: 2,
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                position: 'relative',
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: 6,
                },
              }}
            >
              {/* Badge in top-right corner */}
              {user.is_offer_user && (
                <Box sx={{ position: 'absolute', top: 16, left: "-3rem", zIndex: 1 }}>
                  <Badge
                    color="primary"
                    badgeContent="Pre book"
                    sx={{width:'7rem'}}
                  />
                </Box>
              )}
              <CardContent sx={{ mt: user.is_offer_user ? 2 : 0}}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {`${user.first_name} ${user.last_name}`}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>User ID:</strong> {user.username}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>Email:</strong> {user.email}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>Phone:</strong> {user.phone_number || "N/A"}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>User Type:</strong> {user.user_type}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>Referral Count:</strong> {user.referal_count}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    fontWeight: 600,
                    color: user.is_activated ? "green" : "red",
                  }}
                >
                  {user.is_activated ? "Active" : "Inactive"}
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<RemoveRedEyeIcon />}
                  href={`/user/${user.username}`}
                  sx={{ mt: 2 }}
                  fullWidth
                >
                  View Details
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
      );
    return (
        <Container style={{ padding: "10px", width: "auto" }}>
        <Box sx={{ mt: 1, mb: 1 }}>
          <Typography variant="h4" align="center" gutterBottom>
            All Users
          </Typography>
          {errorMessage && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          )}
          <Box sx={{ mt: 2 }}>
            <Tabs value={activeTab} onChange={handleTabChange} centered>
              <Tab label="Users" />
              <Tab label="Employees" />
            </Tabs>
            <Box sx={{ mt: 2 }}>
              {activeTab === 0 && renderTable(users)}
              {activeTab === 1 && renderTable(employees)}
            </Box>
          </Box>
        </Box>
      </Container>
    );
}
export default AllUsers;